import { useEffect, useRef } from 'react';
import gsap from 'gsap';
import { useNavTheme } from '../hooks/useNavTheme';
import { NavTheme } from '../context/NavContext';

interface HeroImageProps {
  imageUrl: string;
  title?: string;
  subtitle?: string;
  overlayOpacity?: number; // 0 to 1, for darkening the image
  titleClassName?: string;
  subtitleClassName?: string;
  cta?: () => void;
  navTheme?: NavTheme;
}

export function HeroImage({
  imageUrl,
  title,
  subtitle,
  overlayOpacity = 0.5,
  titleClassName,
  subtitleClassName,
  cta,
  navTheme = 'dark',
}: HeroImageProps) {
  const heroRef = useRef<HTMLDivElement>(null);
  const divRef = useRef<HTMLDivElement>(null);
  useNavTheme(heroRef, navTheme);

  useEffect(() => {
    if (divRef.current) {
      gsap.fromTo(
        divRef.current,
        { opacity: 0, y: 50 },
        { opacity: 1, y: 0, duration: 0.7, ease: 'power2.out' }
      );
    }
  }, []);
  return (
    <div
      ref={heroRef}
      className="relative w-full h-screen overflow-hidden"
      style={{ zIndex: 0 }}
    >
      {/* Background Image */}
      <div
        className="absolute inset-0 w-full h-full"
        style={{
          backgroundImage: `url(${imageUrl})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
        }}
      />

      <div
        className="absolute inset-0 pointer-events-none"
        style={
          {
            // background: `linear-gradient(to bottom, #e8e2d9 0px, #e8e2d900 200px)`,
          }
        }
      />

      {/* Dark Overlay */}
      <div
        className="absolute inset-0 bg-black"
        style={{ opacity: overlayOpacity }}
      />

      {/* Text Content */}
      {title || subtitle || cta ? (
        <div
          ref={divRef}
          className="max-w-7xl mx-auto px-6 absolute inset-0 flex flex-col justify-center items-center z-10"
        >
          {title ? (
            <h1
              className={
                titleClassName ||
                'text-4xl md:text-h1 text-white tracking-wide mb-4 text-center'
              }
              style={{
                whiteSpace: 'pre-line',
              }}
            >
              {title}
            </h1>
          ) : null}
          {subtitle ? (
            <p
              className={
                subtitleClassName ||
                'text-xl sm:text-2xl md:text-3xl tracking-wide text-white max-w-3xl mb-6 sm:mb-16'
              }
            >
              {subtitle}
            </p>
          ) : null}
          {cta ? (
            <div>
              <button
                type="button"
                onClick={cta}
                className="w-auto whitespace-nowrap bg-[#00391F] hover:bg-[#004D29] text-neutral tracking-[4px] font-light font-sans text-base py-3 px-10 transition-colors duration-200 mt-2 active:bg-neutral-dark"
              >
                EXPLORE OUR PORTFOLIO
              </button>
            </div>
          ) : null}
        </div>
      ) : null}
    </div>
  );
}
